<template>
  <div>
    <NavButton chevron :toggled="showMenu" class="hidden md:flex" @click="toggleMenu">
      Our moving secrets
    </NavButton>
    <NavMenu :show="showMenu" help-centre @hide="closeAllMenus">
      <div
        class="md:hidden flex cursor-pointer w-[90%] self-start -mt-[28px] mb-ds-ml"
        qa-tag="nav-help-centre-back"
        @click="toggleMenu(false)"
      >
        <img
          src="/content-static/navigation-menu/chevron-left.svg"
          alt="chevron left"
          class="fixed-size"
          loading="lazy"
        />
        <span class="ml-ds-sm font-bold">Our services</span>
      </div>
      <div class="overflow-y-scroll flex flex-col flex-grow gap-ds-sm pr-ds-ml -mr-ds-ml w-[calc(100%+20px)]">
        <NavHelpCentreItem
          url="/blog/moving-house/ten-tip-checklist-for-moving-house"
          @click="$emit('track', 'help-centre', 'ten-checklist')"
        >
          <template #image>
            <img
              src="/content-static/navigation-menu/help-centre/menu-blog-clipboard.webp"
              alt="clipboard"
              loading="lazy"
              style="--image-width: 72px; --image-height: 72px"
            />
          </template>
          <template #title>
            <p>10 things to do when you move</p>
          </template>
          <template #description>
            <p>Our moving checklist covers the top 10 things to do when you move homes.</p>
          </template>
        </NavHelpCentreItem>
        <NavHelpCentreItem
          url="/removals/home-removals/packing-tips-moving-house"
          @click="$emit('track', 'help-centre', 'packing-tips')"
        >
          <template #image>
            <img
              src="/content-static/navigation-menu/help-centre/menu-blog-boxes.webp"
              alt="boxes"
              loading="lazy"
              style="--image-width: 72px; --image-height: 72px"
            />
          </template>
          <template #title>
            <p>Packing tips to help you move</p>
          </template>
          <template #description>
            <p>Don't underestimate the packing process! Our tips will help you tackle the job.</p>
          </template>
        </NavHelpCentreItem>
        <NavHelpCentreItem
          url="/removals/home-removals/what-size-removals-van-do-i-need"
          @click="$emit('track', 'help-centre', 'what-size-van')"
        >
          <template #image>
            <img
              src="/content-static/navigation-menu/help-centre/menu-blog-van.webp"
              alt="van"
              loading="lazy"
              style="--image-width: 72px; --image-height: 72px"
            />
          </template>
          <template #title>
            <p>Choosing the right size van</p>
          </template>
          <template #description>
            <p>Knowing what size removal van you'll need can be tricky. Our guide explains all.</p>
          </template>
        </NavHelpCentreItem>
        <NavHelpCentreItem
          url="/removals/home-removals/do-i-need-moving-insurance"
          @click="$emit('track', 'help-centre', 'insurance')"
        >
          <template #image>
            <img
              src="/content-static/navigation-menu/help-centre/menu-blog-brolly.webp"
              alt="brolly"
              loading="lazy"
              style="--image-width: 72px; --image-height: 72px"
            />
          </template>
          <template #title>
            <p>Why you need moving insurance</p>
          </template>
          <template #description>
            <p>
              Wondering if you need moving insurance? In short, yes. Here's why it's so important
            </p>
          </template>
        </NavHelpCentreItem>
        <NavHelpCentreItem
          url="/removals/home-removals/how-to-pack-fragile-items-for-moving"
          @click="$emit('track', 'help-centre', 'fragile-items')"
        >
          <template #image>
            <img
              src="/content-static/navigation-menu/help-centre/menu-blog-vase.webp"
              alt="vase"
              loading="lazy"
              style="--image-width: 72px; --image-height: 72px"
            />
          </template>
          <template #title>
            <p>How to pack fragile items</p>
          </template>
          <template #description>
            <p>
              Here's how to make sure your prized possessions arrive safely when you're moving them.
            </p>
          </template>
        </NavHelpCentreItem>
        <NavHelpCentreItem
          url="/removals/how-to-pack-for-international-move"
          @click="$emit('track', 'help-centre', 'international')"
        >
          <template #image>
            <img
              src="/content-static/navigation-menu/help-centre/menu-blog-balloon.webp"
              alt="balloon"
              loading="lazy"
              style="--image-width: 72px; --image-height: 72px"
            />
          </template>
          <template #title>
            <p>Packing for an international move</p>
          </template>
          <template #description>
            <p>
              Our guide on how to pack when moving abroad will help you prepare for a low-stress
              relocation.
            </p>
          </template>
        </NavHelpCentreItem>
        <NavHelpCentreItem
          url="/blog/saving-money/moving-house-storage-tips"
          @click="$emit('track', 'help-centre', 'storage-tips')"
        >
          <template #image>
            <img
              src="/content-static/navigation-menu/help-centre/menu-blog-storage.webp"
              alt="storage"
              loading="lazy"
              style="--image-width: 72px; --image-height: 72px"
            />
          </template>
          <template #title>
            <p>The AnyVan guide to storage</p>
          </template>
          <template #description>
            <p>
              Moving homes can make you realise how much you own. If you need storage options then
              read on!
            </p>
          </template>
        </NavHelpCentreItem>
      </div>
      <div class="h-ds-md w-full border-t border-t-black10 -mt-ds-sm">
        <div class="w-full flex justify-center items-center h-full mt-ds-md">
          <img
            class="w-ds-ml fixed-size"
            src="/content-static/navigation-menu/chevron-down-2.svg"
            alt="chevron down"
            loading="lazy"
            style="--image-width: 72px; --image-height: 72px"
          />
        </div>
        <a
          href="/removals/advice"
          class="absolute bottom-[26px] translate-y-2/4 flex right-ds-lg no-underline text-sm text-base-dark hover:no-underline hover:text-base-dark focus:no-underline focus:text-base-dark"
          qa-tag="nav-help-centre-view-all"
        >
          <span class="opacity-50">View all</span>
          <img
            class="ml-ds-xxs fixed-size"
            src="/content-static/navigation-menu/chevron-right.svg"
            alt="chevron right"
            loading="lazy"
            style="--image-width: 72px; --image-height: 72px"
          />
        </a>
      </div>
    </NavMenu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import NavHelpCentreBase from "~/components/base/navHelpCentre"

export default defineComponent({
  name: "NavHelpCentreEn",
  extends: NavHelpCentreBase
})
</script>
